export default __webpack_public_path__ + "static/media/nature.36b2003b.png";